'use client'

import React, { useState } from 'react'
import { Card } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { ArrowLeft, Heart } from 'phosphor-react'
import { Link } from '@/lib'
import Components from '../components'

export default function VolunteerWork() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null)

  const projects: Array<{ title: string; image?: string; description: string; year?: string; organization?: string }> = [
    // Add your volunteer projects here
  ]

  return (
    <Components.PageContainer>
      <Components.SkipLink />
      <Components.GlassNavigation />
      
      <main id="main-content" tabIndex={-1} className="pt-16 md:pt-32 pb-16 px-4 md:px-6" role="main" aria-label="Volunteer Work">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <header className="mb-8 md:mb-12">
            <Button
              asChild
              variant="ghost"
              className="mb-6 text-[var(--brutal-ink)] hover:bg-[var(--brutal-panel)]"
            >
              <Link to="/CreativeProjects">
                <ArrowLeft weight="duotone" className="w-4 h-4 mr-2" />
                Back to Creative Projects
              </Link>
            </Button>
            
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-pink-500/20 to-rose-500/20 rounded-full flex items-center justify-center">
                <Heart weight="duotone" className="w-6 h-6 text-[var(--brutal-accent)]" />
              </div>
              <div>
                <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[var(--brutal-ink)] leading-tight break-words">
                  Volunteer Work
                </h1>
                <p className="text-base md:text-lg text-[var(--brutal-muted)] mt-2 break-words">
                  Pro bono design projects for local nonprofits and community organizations, focusing on accessibility and social impact
                </p>
              </div>
            </div>
          </header>

          {/* Projects List */}
          {projects.length > 0 ? (
            <section className="grid grid-cols-1 md:grid-cols-2 gap-6" aria-label="Volunteer projects">
              {projects.map((project, index) => (
                <Card
                  key={index}
                  className="group relative overflow-hidden brutal-panel hover:bg-[var(--brutal-kraft)] transition-all duration-300 hover:scale-[1.02] hover:shadow-2xl"
                >
                  {project.image && (
                    <div className="relative aspect-video overflow-hidden">
                      <img
                        src={project.image}
                        alt={project.title}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110 cursor-pointer"
                        onClick={() => setSelectedImage(project.image!)}
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    </div>
                  )}
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-[var(--brutal-ink)] mb-2 group-hover:text-[var(--brutal-accent)] transition-colors duration-200 break-words">
                      {project.title}
                    </h3>
                    {project.organization && (
                      <p className="text-[var(--brutal-accent)] text-sm mb-2 font-medium">{project.organization}</p>
                    )}
                    {project.year && (
                      <p className="text-[var(--brutal-muted)] text-xs mb-3">{project.year}</p>
                    )}
                    <p className="text-[var(--brutal-muted)] leading-relaxed break-words">
                      {project.description}
                    </p>
                  </div>
                </Card>
              ))}
            </section>
          ) : (
            <Card className="brutal-panel p-12 text-center">
              <p className="text-[var(--brutal-muted)] text-lg">Volunteer projects coming soon...</p>
            </Card>
          )}
        </div>
      </main>

      {/* Image Modal */}
      {selectedImage && (
        <Components.ImageModal
          src={selectedImage}
          alt="Volunteer Work"
          onClose={() => setSelectedImage(null)}
        />
      )}
    </Components.PageContainer>
  )
}
